/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BillingChangePreviewResponseCurrentCadence = typeof BillingChangePreviewResponseCurrentCadence[keyof typeof BillingChangePreviewResponseCurrentCadence];


export const BillingChangePreviewResponseCurrentCadence = {
  monthly: 'monthly',
  annual: 'annual',
} as const;
